import cn from 'classnames';
import { TMaxPlayers, TRoomSlug } from '@api/types/blackjack';
import { ROOM } from '@consts/blackjack';
import styles from './card.module.scss';
import { CSSProperties } from 'react';

export type TCardSize = 'normal' | 'big';

interface ICardProps {
  back?: TRoomSlug;
  card?: string;
  className?: string;
  phantom?: TRoomSlug;
  size: TCardSize;
  style?: CSSProperties;
}

const SYMBOLS: { [key: string]: string } = {
  C: '♣',
  D: '♦',
  H: '♥',
  S: '♠',
};

const MAX_PLAYERS = 2;

const Card = ({
  back,
  card = '',
  className = '',
  phantom,
  size,
  style = {},
}: ICardProps): JSX.Element => {
  const number: string = card.length > 3 ? card.substring(0, 2) : card[0];
  const symbolLetter: string = card[card.length - 1];
  const symbol: string = SYMBOLS[symbolLetter];

  /* ClassNames */

  const cardClasses = cn(styles.card, className, {
    [styles.big]: size === 'big',
    [styles[`card-phantom-${phantom}`]]: phantom,
    [styles.redSymbol]: symbolLetter === 'D' || symbolLetter === 'H',
    [styles.back]: back,
  });

  /* Components */

  const BackCard: JSX.Element = (
    <figure className={cardClasses} {...{ style }}>
      {ROOM.CARDS_BACK[MAX_PLAYERS as TMaxPlayers]}
    </figure>
  );

  const PhantomCard: JSX.Element = (
    <figure className={cardClasses} {...{ style }} />
  );

  const Card: JSX.Element = (
    <figure className={cardClasses} {...{ style }}>
      <div className={styles.wrapper}>
        <h3>{number}</h3>
        <p>{symbol}</p>
      </div>
    </figure>
  );

  return (
    <>
      {phantom && PhantomCard}
      {back && BackCard}
      {card !== '' && Card}
    </>
  );
};

export default Card;
